import React, { useEffect } from "react";

//Styles
import "./RevealOnScroll.scss";

function RevealOnScroll({ children, threshold = 0.7 }) {
  const [isVisible, setVisible] = React.useState(false);
  const domRef = React.useRef();
  const usedThreshold = document.documentElement.clientHeight > 800 ? threshold : 0.3;
  useEffect(() => {
    const element = domRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => entry.isIntersecting && setVisible(entry.isIntersecting));
      },
      { threshold: usedThreshold }
    );
    observer.observe(element);
    return () => observer.unobserve(element);
  }, [usedThreshold]);
  return (
    <div className={"scroll-reveal" + (!isVisible ? " not-visible" : "")} ref={domRef}>
      {children}
    </div>
  );
}
export default RevealOnScroll;
